// cacheConstants.ts
export const CACHE_TTL = {
  GROUP_DATA: 30 * 60 * 1000,           // 30 минут
  DEPARTMENT_INFO: 5 * 60 * 1000,       // 5 минут для информации отделения
  DEPARTMENT_SCHOLARSHIPS: 5 * 60 * 1000, // 5 минут для статистики стипендий
  GROUP_STUDENTS: 5 * 60 * 1000,        // 5 минут
  GROUP_AVERAGE: 5 * 60 * 1000,         // 5 минут для средних оценок
  GROUP_ATTENDANCE: 5 * 60 * 1000,      // 5 минут для посещаемости
  TEACHER_DATA: 60 * 60 * 1000,         // 1 час
  SUBJECT_DATA: 60 * 60 * 1000,         // 1 час
  STUDENT_MARKS: 5 * 60 * 1000,         // 5 минут
  DOCUMENTS: 5 * 60 * 1000,             // 5 минут
  USER_DATA: 24 * 60 * 60 * 1000,       // 24 часа
  TEACHER_DISCIPLINES: 24 * 60 * 60 * 1000,
  MARKS_DATA: 2 * 60 * 1000,
  STUDENT_DATA: 10 * 60 * 1000,
  LESSON_DATES: 30 * 60 * 1000,
  LESSON_INFO: 10 * 60 * 1000,
  SUBJECT_TEACHERS: 30 * 60 * 1000,
  SUBGROUP_TEACHERS: 5 * 60 * 1000,
  SUBGROUP_DATA: 2 * 60 * 1000,
  LESSON_TYPES: 24 * 60 * 60 * 1000,
  ATTENDANCE_DATA: 5 * 60 * 1000,
  GROUP_INFO: 30 * 60 * 1000,
  CERTIFICATION_DATA: 3600000,
  SOCIAL_DATA: 3600000,
  GROUP_STATS: 30 * 60 * 1000,        // 30 минут — статистика по группам
  ORPHANS_DATA: 10 * 60 * 1000,       // 10 минут — сироты
  INVALIDS_DATA: 10 * 60 * 1000,  
};